
import { Component, Vue } from 'vue-property-decorator'
import { chooseFile, openCamera } from '@/utils/h5ToApp'

@Component
export default class SelectIconTypePop extends Vue {
  popShow = false
  extraQuery: any = {}

  onSelectFromAlbum() {
    const data = {
      fileType: '1',
      maxFileCount: '1'
    }
    chooseFile(data).then((res: any) => {
      const filePath = res[0].filePath
      this.popShow = false
      // 跳转到编辑图片页面，传递图片路径
      this.$router.push({
        name: 'EditIcon',
        query: {
          filePath: filePath,
          ...this.extraQuery
        }
      })
    }).catch((err: any) => {
      console.error('选择文件失败:', err)
    })
  }
  onTakePhoto() {
    openCamera().then((res: any) => {
      if (res) {
        this.popShow = false
        // 存入 sessionStorage 避免 url 过长
        sessionStorage.setItem('temp_camera_photo', res)
        this.$router.push({
          name: 'EditIcon',
          query: {
            source: 'camera',
            ...this.extraQuery
          }
        })
      }
    })
  }
  
  onGenerate() {
    this.popShow = false
    // 跳转到自动生成图标页面
    this.$router.push({
      name: 'AutoCreateIcon',
      query: {
        ...this.extraQuery
      }
    })
  }
  onCancel() {
    this.popShow = false
  }
  showPop(query?: any) {
    this.popShow = true
    this.extraQuery = query || {}
  }
}
